/**
 * SiteMapOverlay Component
 * Displays the Overlay with "open button" when SiteMap is closed (init state)
 */
const SiteMapOverlay: React.FC<{
	setOpened: (isOpen: boolean) => void;
	exploreMoreLabel: string;
}> = ({ setOpened, exploreMoreLabel }) => {
	return (
		<div className="site-map-overlay">
			<button
				className="blk-ac-secondary-button-on-black"
				onClick={() => setOpened(true)}
				aria-label={exploreMoreLabel}
				data-link-event={`sitemap:${exploreMoreLabel}`}
			>
				{exploreMoreLabel}
			</button>
		</div>
	);
};

export default SiteMapOverlay;
